<template>
    <div id="goTop">
        <div class="goTop" v-show="goTopShow" @click="goTop">
            <img src="../../assets/imgs/backtop.png" alt="">
        </div>
    </div>
</template>
<script>
export default {
  name: 'goTop',
  data () {
    return {
      scrollTop: '',
      goTopShow: false
    }
  },
  watch: {
    scrollTop (val) {
      if (this.scrollTop > 500) {
        this.goTopShow = true
      } else {
        this.goTopShow = false
      }
    }
  },
  methods: {
    handleScroll () {
      this.scrollTop =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop
      if (this.scrollTop > 500) {
        this.goTopShow = true
      }
    },
    goTop () {
      let timer = null
      const _that = this
      cancelAnimationFrame(timer)
      timer = requestAnimationFrame(function fn () {
        if (_that.scrollTop > 0) {
          _that.scrollTop -= 50
          document.body.scrollTop = document.documentElement.scrollTop =
                        _that.scrollTop
          timer = requestAnimationFrame(fn)
        } else {
          cancelAnimationFrame(timer)
          _that.goTopShow = false
        }
      })
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="scss" scoped>
.goTop {
    z-index: 9999;
    position: fixed;
    right: 40px;
    bottom: 60px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(20, 109, 247, 1);
    padding: 10px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
        width: 30px;
        height :30px;
        color: #fff;
    }
}
.goTop:hover {
    color: rgba(51, 153, 255, 1);
}
</style>
